import React, { InputHTMLAttributes } from 'react';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

interface IareaInput extends InputHTMLAttributes<HTMLInputElement>{
}

const AreaInput: React.FC<IareaInput> = ({ ...inputProps }) => {
	const defaultMaskOptions = {
	  prefix: '',
	  suffix: ' m²',
	  includeThousandsSeparator: true,
	  thousandsSeparatorSymbol: '',
	  allowDecimal: true,
	  decimalSymbol: ',',
	  decimalLimit: 2, // how many digits allowed after the decimal
	  //integerLimit: 7, // limit length of integer numbers
	  allowNegative: false,
	  allowLeadingZeroes: false,
	}

	const areaMask = createNumberMask({
  	...defaultMaskOptions,
	})

	return <MaskedInput mask={areaMask} {...inputProps} />
}

export default AreaInput